"use server";

import { type ChatMessage } from "@/lib/types"
import { cookies } from "next/headers";

const MAX_TITLE_LENGTH = 80;

export async function generateTitleFromUserMessage({
  message,
}: {
  message: ChatMessage
}): Promise<string> {
  return Promise.resolve().then(() => {
    if (!message) return "New Chat"

    // --- Extract text from parts ---
    let rawText = ""
    if (Array.isArray(message.parts) && message.parts.length > 0) {
      const textPart = message.parts.find((p) => p.type === "text")
      rawText = textPart?.text?.trim() || ""
    }

    if (!rawText) return "New Chat"

    // --- Cleanup ---
    let title = rawText
      .replace(/\s+/g, " ") // collapse spaces
      .replace(/["':]/g, "") // remove quotes/colons
      .trim()

    // --- Truncate safely ---
    if (title.length > MAX_TITLE_LENGTH) {
      let safeCutIndex = title.lastIndexOf(" ", MAX_TITLE_LENGTH - 3)
      if (safeCutIndex < MAX_TITLE_LENGTH * 0.75) {
        safeCutIndex = MAX_TITLE_LENGTH
      }
      title = title.substring(0, safeCutIndex).trim() + "..."
    }

    // --- Capitalize first letter ---
    if (title.length > 0) {
      title = title.charAt(0).toUpperCase() + title.slice(1)
    }

    return title || "New Chat"
  })
}


/**
 * Saves the selected chat model as a cookie for user preference.
 */
export async function saveChatModelAsCookie(model: string) {
  const cookieStore = await cookies();
  cookieStore.set("chat-model", model);
}
